export default {
  CONTENT_MGMT_LIST_REQUEST: 'APP/CONTENT_MGMT/CONTENT_MGMT_LIST_REQUEST',
  CONTENT_MGMT_LIST_SUCCESS: 'APP/CONTENT_MGMT/CONTENT_MGMT_LIST_SUCCESS',
  CONTENT_MGMT_LIST_ERROR: 'APP/CONTENT_MGMT/CONTENT_MGMT_LIST_ERROR',
};
